"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward/useCallforward"));
const react_1 = __importStar(require("react"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("../TextFieldWithStateAndBlur/TextFieldWithStateAndBlur"));
exports.default = react_1.default.memo((props) => {
    var _a, _b, _c, _d;
    const { onBlur, phoneNumber = '' } = props, otherProps = __rest(props, ["onBlur", "phoneNumber"]);
    const [currentCode, setCurrentCode] = (0, react_1.useState)((_b = (_a = phoneNumber) === null || _a === void 0 ? void 0 : _a.split('.')) === null || _b === void 0 ? void 0 : _b[0]);
    const [currentNumber, setCurrentNumber] = (0, react_1.useState)((_d = (_c = phoneNumber) === null || _c === void 0 ? void 0 : _c.split('.')) === null || _d === void 0 ? void 0 : _d[1]);
    const handleBlur = (0, useCallforward_1.default)(type => text => {
        if (!onBlur)
            return;
        if (type === 'code') {
            if (!(text === null || text === void 0 ? void 0 : text.startsWith('+'))) {
                text = '+' + text;
            }
            setCurrentCode(text);
            onBlur(text + '.' + currentNumber);
        }
        else {
            setCurrentNumber(text);
            onBlur(currentCode + '.' + text);
        }
    }, [onBlur, currentNumber, currentCode, setCurrentCode, setCurrentNumber]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TextFieldWithStateAndBlur_1.default, Object.assign({ inputProps: {
                style: {
                    width: 50,
                },
                min: 3,
                max: 3,
            }, value: currentCode, onBlur: handleBlur('code') }, otherProps)),
        react_1.default.createElement("span", { style: { paddingRight: 10 } }, " "),
        react_1.default.createElement(TextFieldWithStateAndBlur_1.default, Object.assign({ type: 'number', inputProps: {
                style: {
                    width: 100,
                },
                min: 10,
                max: 10,
            }, value: currentNumber, onBlur: handleBlur('number') }, otherProps))));
});
